import angular from 'angular';
import uiRouter from 'angular-ui-router';
import userDetailsComponent from './userDetails.component';
import changePasswordComponent from './changePassword/changePassword';
import phoneValidationComponent from './phoneValidation/phoneValidation';

const userDetailsModule = angular
  .module('userDetails', [uiRouter, changePasswordComponent, phoneValidationComponent])
  .component('userDetails', userDetailsComponent)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('main.user.userDetails', {
      url: '/:id',
      component: 'userDetails',
      resolve: {
        user($stateParams, User) {
          return User.getUser($stateParams.id);
        },
      },
    });
  }).name;

export default userDetailsModule;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/userDetails.js